import { Component, Vue } from 'vue-property-decorator';
import { sessionService } from '@/providers/services/auth/session';
import { Events } from '@/events';
import AppHeaderNav from '@/layouts/app-header-layout/app-header-nav/app-header-nav.vue';
import { authAPI } from '@/providers/apis/auth/auth';
import { NAVIGATION_MENUS } from '@/utils/constants';
import RoleList from '@/components/cards/role-list/role-list';
import { demoUser } from '@/providers/apis/demo-user/demo-user';

@Component({
  components: {
    AppHeaderNav,
    RoleList,
  },
})
export default class AppHeaderLayout extends Vue {

  // -------------------------------------------------------------------------
  // Properties

  private currentRouteName: string = 'network';

  private appList: any = [];

  /**
   * @returns {boolean} isDemoUser help to show the user role list
   */
  private isShowRole: boolean = false;

  private get isHideRoleMenu() {
    return this.session && this.session!.isHideRoleMenu ? this.session!.isHideRoleMenu : false;
  }

  /**
   * Help to identify demo user
   */
  private get isDemoUser() {
    return this.$access.hasPermission(this.$access.menus.nav, this.$access.ACL.roleView)
              || sessionService.getDemoSessionCopy()
              || this.$access.hasPermission(this.$access.menus.all, this.$access.ACL.all);
  }

  // -------------------------------------------------------------------------
  // Computed Properties

  /**
   * It will fetch current session object.
   * @return {SessionModel}
   */
  get session() {
    return sessionService.getSession();
  }

  get isImpersonateUser() {
    return this.session!.isImpersonateUser;
  }

  public get logoUrl() {
    return this.$access.getAssets(null, 'logo');
  }
  // -------------------------------------------------------------------------
  // Actions


  private doLogout() {
    authAPI.signOut().then(() => {
      sessionService.deleteSession();
      this.$router.push('/login');
    });
  }

  private closeAppNav() {
    (this.$refs.appSideNav as HTMLFormElement).style.width = '0px';
  }

  private openAppNav() {
    (this.$refs.appSideNav as HTMLFormElement).style.width = '300px';
  }

  private onChangeRoute(currentRoutePath: string) {
    (this.$refs.appSideNav as HTMLFormElement).style.width = '0px';
    this.setCurrentRouteName(currentRoutePath);
  }

  private onShowRoleList() {
    if (this.$access.isDemoTenant || sessionService.getDemoSessionCopy()) {
      this.isShowRole = !this.isShowRole;
    }
  }

  // -------------------------------------------------------------------------
  // Hooks

  private mounted() {
    const currentRoutePath = this.$router.currentRoute.path;
    this.setCurrentRouteName(currentRoutePath);
    if (this.session && this.session.access_token) {
      authAPI.setImpersonateToken(this.session.access_token);
    }
    demoUser.userAppList().then((appList) => {
      this.appList = appList;
    });
  }

  // -------------------------------------------------------------------------
  // Methods

  private setCurrentRouteName(currentRoutePath: string) {
    const selectedMenuItems = NAVIGATION_MENUS.filter((menuItem, index) => {
      return menuItem.path === currentRoutePath ? menuItem : null;
    });
    const selectedMenuItem = selectedMenuItems[0];
    if (selectedMenuItem) {
      this.currentRouteName = selectedMenuItem.name;
    }
  }
}
